//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';

import styled, { css } from 'styled-components';

interface Props {
  children: React.ReactNode;
  className?: string;
  forceWidth?: number;
}

export const MediaGrid = (props: Props) => {
  const { children, forceWidth, className } = props;
  const numItems = React.Children.count(children);
  const squareChildren = React.Children.map(children, (child) => (
    <GridChildSquare>
      <GridChildContainer>{child}</GridChildContainer>
    </GridChildSquare>
  ));

  return (
    <MediaGridContainer className={className}>
      <Grid numItems={numItems} forceWidth={forceWidth}>
        {squareChildren}
      </Grid>
    </MediaGridContainer>
  );
};

const MediaGridContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  position: relative;
  width: 100%;
`;

const getGrid = (numItems: number, forceWidth?: number) => {
  if (forceWidth === 4 || numItems > 9) {
    return css`
      grid-template-columns: repeat(4, 1fr);
    `;
  }
  if (forceWidth === 3 || numItems > 4) {
    return css`
      grid-template-columns: repeat(3, 1fr);
    `;
  }
  if (forceWidth === 2 || numItems > 1) {
    return css`
      grid-template-columns: repeat(2, 1fr);
    `;
  }
  if (forceWidth === 1 || numItems === 1) {
    return css`
      grid-template-columns: 1fr;
    `;
  }
};

interface IGridProps {
  numItems: number;
  forceWidth: number;
}

const Grid = styled.div<IGridProps>`
  display: grid;
  grid-gap: ${({ theme }) => theme.spacings[3]};
  grid-auto-rows: 1fr;
  ${({ numItems, forceWidth }) => getGrid(numItems, forceWidth)}
  width: 100%;
`;

const GridChildSquare = styled.div`
  position: relative;

  :before {
    content: '';
    display: block;
    width: 100%;
    padding-top: 100%;
  }
`;

const GridChildContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
